import React, { useState, useEffect } from "react";
import { SmallCard } from "../Cards/SmallCard";
import {
  get,
  post,
  put,
  deleteRequestV2,
} from "../../api/usersModule/httpClient";
import { useDebounce } from "../../hooks/useDebounce";
import { CDBModal } from "cdbreact";
import { ModalQualitys } from "../Modals/ModalQualitys";
import { LargeCard } from "../Cards/LargeCard";
import swal from "sweetalert";
import Swal from "sweetalert2";

const usersheaders = [
  "Lote",
  "Código SAP",
  "Descripción",
  "Código Proveedor",
  "Proveedor",
  "Unidades recibidas",
  "Unidades defectuosas",
  "% Defectuosas",
  "% Aprobadas",
  "Descripción",
  "Fecha de modificación",
  "Usuario",
  "/reception",
];

const defaultFormData = {
  LotNumber: "",
  CodeSap: "",
  UnitsQualitysReception: 0,
  UnitsQualitysDefective: 0,
  ReceptionsDescription: "",
};

export const CrudQualitysReceptions = ({
  userName,
  permissions,
  project,
  nit,
  codeSap,
  change,
}) => {
  const [data, setData] = useState([]);
  const [state, setState] = useState({ modal6: false });
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [pressedButton, setPressedButton] = useState("");
  const [action, setAction] = useState("");
  const [receptions, setReceptions] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [initialRender, setInitialRender] = useState(true);
  const [changePage, setChangePage] = useState(false);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  const getReception = async () => {
    try {
      const response = await get(`/receptions?Nit=${project}&List=True`);
      if (response && response.items) {
        setReceptions(response.items);
      } else {
        console.error("Error fetching receptions: No items found in response");
        swal(
          "Error",
          "No se encontraron recepciones. Por favor, inténtelo de nuevo más tarde.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching receptions:", error);
      swal(
        "Error",
        "Error al obtener las recepciones. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
    }
  };

  const getQuality = async (LotNumber) => {
    try {
      const response = await get(
        `/qualitysReceptions?LotNumber=${LotNumber.split("/*-/")[0]}&Nit=${
          LotNumber.split("/*-/")[1]
        }`
      );
      if (response && response.items && response.items.length > 0) {
        setFormData(response.items[0]);
        toggle(6)();
      } else {
        console.error("Error fetching quality: No items found in response");
        swal(
          "Error",
          "No se encontraron datos de calidad para el número de lote proporcionado. Por favor, inténtelo de nuevo más tarde.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching quality:", error);
      swal(
        "Error",
        "Error al obtener datos de calidad. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
    }
  };

  const getQualitysReceptions = async (search, statusPage) => {
    try {
      setLoading(true);
      let response;
      if (codeSap != "" && codeSap != null && codeSap != undefined) {
        response = await get(
          `/qualitysReceptions?page=${statusPage}&search=${search}&CodeSap=${codeSap}&Nit=${nit}&limit=${itemsPerPage}`
        );
      } else {
        response = await get(
          `/qualitysReceptions?page=${statusPage}&search=${search}&Nit=${project}&limit=${itemsPerPage}`
        );
      }
      if (response && response.answer) {
        setTotalItems(response.pagination.totalItems);
        setData(response.items);
      } else {
        console.error(
          "Error fetching quality receptions: Unexpected response format"
        );
        setTotalItems(0);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching quality receptions:", error);
      swal(
        "Error",
        "Error al obtener las recepciones de calidad. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
      setTotalItems(0);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setState({ ...state, modal6: false });
  };

  const toggle = (nr) => () => {
    let modalNumber = "modal" + nr;
    setState({ ...state, [modalNumber]: !state[modalNumber] });
  };

  const handleChange = (targets) => {
    targets.forEach((target) => {
      const { id, value } = target;
      setFormData((prevData) => ({ ...prevData, [id]: value }));
    });
  };

  const convertDataToArray = () => {
    try {
      if (!data || !Array.isArray(data)) {
        return [];
      }

      return data.map((item) => {
        const totalUnidades = parseFloat(item.UnitsQualitysReception).toFixed(2);
        const unidadesDefectuosas = parseFloat(item.UnitsQualitysDefective).toFixed(2);

        const porcentajeBuenas =
          totalUnidades !== 0
            ? ((totalUnidades - unidadesDefectuosas) / totalUnidades) * 100
            : 0;
        const porcentajeDefectuosas =
          totalUnidades !== 0 ? (unidadesDefectuosas / totalUnidades) * 100 : 0;

        return [
          item.LotNumber ? item.LotNumber.toUpperCase() : "",
          item.CodeSap ? item.CodeSap.toUpperCase() : "",
          item.SkuDescription ? item.SkuDescription.toUpperCase() : "",
          item.Nit ? item.Nit.toUpperCase() : "",
          item.ProjectName ? item.ProjectName.toUpperCase() : "",
          totalUnidades || 0,
          unidadesDefectuosas || 0,
          parseFloat(porcentajeDefectuosas).toFixed(2) + "%",
          parseFloat(porcentajeBuenas).toFixed(2) + "%",
          item.ReceptionsDescription || "",
          item.ModificationDate || "",
          item.User.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ") || "",
        ];
      });
    } catch (error) {
      console.error("Error converting data to array:", error);
      return [];
    }
  };

  const handleSubmit = () => {
    const requiredFields = [
      "LotNumber",
      "CodeSap",
      "UnitsQualitysReception",
      "UnitsQualitysDefective",
      "ReceptionsDescription",
    ];

    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      swal("Error", "Por favor, rellene todos los campos", "error");
      setLoading(false);
      return false;
    }

    if (formData.UnitsQualitysDefective > formData.UnitsQualitysReception) {
      swal(
        "Error",
        "Las unidades defectuosas no pueden ser mayores que las unidades recibidas",
        "error"
      );
      setLoading(false);
      return false;
    }

    return true;
  };

  const saveData = async () => {
    Swal.fire({
      title: `${
        action === "create" ? "Creando" : "Actualizando"
      } Calidad de Recepción`,
      text: "Por favor, espere...",
      icon: "info",
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    const {
      LotNumber,
      CodeSap,
      UnitsQualitysReception,
      UnitsQualitysDefective,
      ReceptionsDescription,
      Nit,
    } = formData;
    const User = userName || "Admin";

    try {
      const response = await (action === "create" ? post : put)(
        "/qualitysReceptions",
        {
          LotNumber: LotNumber.toUpperCase(),
          CodeSap: CodeSap.toUpperCase(),
          Nit: Nit.toUpperCase(),
          UnitsQualitysReception: parseFloat(UnitsQualitysReception),
          UnitsQualitysDefective: parseFloat(UnitsQualitysDefective),
          ReceptionsDescription: ReceptionsDescription.toUpperCase(),
          User: User.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" "),
        }
      );

      Swal.close();
      if (
        (response && response.response && response.response.status !== 200) ||
        !response.answer
      ) {
        swal(
          "Error",
          `No se pudo ${
            action === "create" ? "crear" : "actualizar"
          } la calidad de recepción. Por favor, revise la información (Puede deberse, a que ya existe un registro con el mismo LOTE).`,
          "error"
        );
      } else if (response.answer) {
        toggle(6)();
        swal(
          `Calidad de Recepción ${
            action === "create" ? "creada" : "actualizada"
          }`,
          `La calidad de recepción. se ${
            action === "create" ? "creó" : "actualizó"
          } correctamente.`,
          "success"
        );
      }

      getQualitysReceptions("", 1);
    } catch (error) {
      Swal.close();
      console.error(
        `Error al ${
          action === "create" ? "crear" : "actualizar"
        } la calidad de recepción:`,
        error
      );
    }
  };

  const deleteQuality = async () => {
    try {
      const {
        LotNumber,
        CodeSap,
        UnitsQualitysReception,
        UnitsQualitysDefective,
        Nit,
      } = formData;
      const User = userName || "Admin";

      const body = JSON.stringify({
        CodeSap,
        LotNumber,
        Nit,
        UnitsQualitysReception: parseFloat(UnitsQualitysReception),
        UnitsQualitysDefective: parseFloat(UnitsQualitysDefective),
        User,
      });

      const confirmDelete = await Swal.fire({
        title: "Confirmar Eliminación de la Calidad de Recepción",
        text: "Esta acción eliminará de manera permanente la Calidad de Recepción seleccionada, junto con cualquier dato relacionado. ¿Está seguro de que desea proceder?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#146284",
        cancelButtonColor: "#EF4444",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });

      if (confirmDelete.isConfirmed) {
        Swal.fire({
          title: "Eliminando Calidad de Recepción",
          text: "Por favor, espere...",
          icon: "info",
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        await deleteRequestV2("qualitysReceptions", body, true);

        Swal.close();

        toggle(6)();
        getQualitysReceptions("", 1);
      }
    } catch (error) {
      console.error("Error deleting quality reception:", error);
      swal(
        "Error",
        "Error al eliminar la Calidad de Recepción. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    if (!changePage) {
      getQualitysReceptions(debouncedSearch, page);
    } else {
      setChangePage(false);
    }
  }, [page, initialRender, change]);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }
    getQualitysReceptions(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }
    getQualitysReceptions(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [itemsPerPage]);

  useEffect(() => {
    switch (pressedButton.split(",")[0]) {
      case "create":
        if (permissions["Crear"]) {
          getReception();
          setAction("create");
          setFormData(defaultFormData);
          toggle(6)();
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para crear una calidad de recepción",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "edit":
        if (permissions["Editar"]) {
          setAction("edit");
          getReception();
          getQuality(pressedButton.split(",")[1]);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para editar una calidad de recepción",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "delete":
        if (permissions["Eliminar"]) {
          deleteQuality(pressedButton.split(",")[1]);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para borrar calidad de recepción",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "refresh":
        getQualitysReceptions(debouncedSearch, page);
        break;
      case "closeModal":
        toggle(6)();
        break;
      case "submitModal":
        const success = handleSubmit();
        if (success) {
          saveData();
        }
        break;
      default:
        break;
    }
    setPressedButton("");
  }, [pressedButton]);

  return (
    <>
      <LargeCard
        name="Calidad en el proceso"
        headers={usersheaders}
        loading={loading}
        data={convertDataToArray()}
        totalItems={totalItems}
        customTable={false}
        setPressedButton={setPressedButton}
        setPage={setPage}
        page={page}
        setChangePage={setChangePage}
        setSearch={setSearch}
        cState={true}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />
      <CDBModal isOpen={state.modal6} toggle={toggle(6)}>
        <ModalQualitys
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          closeModal={closeModal}
          handleChange={handleChange}
          receptions={receptions}
          setFormData={setFormData}
        />
      </CDBModal>
    </>
  );
};
